import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    BigSmartStatus,
    CreateBigSmartStatusInput,
    UpdateBigSmartStatusInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class BigSmartStatusService {
    private amplifyClient = generateClient();
    constructor() {}

    async listBigSmartStatuses(): Promise<BigSmartStatus[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listBigSmartStatuses
                })
            ).data.listBigSmartStatuses.items;
            if (data) return data as BigSmartStatus[];
        } catch (error) {
            console.error('Error finding BigSmartStatus:', error);
            return null;
        }
    }

    async createBigSmartStatus(
        input: CreateBigSmartStatusInput
    ): Promise<BigSmartStatus> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createBigSmartStatus,
                    variables: {
                        input
                    }
                })
            ).data.createBigSmartStatus;
            if (date) return date as BigSmartStatus;
        } catch (error) {
            console.error('Error creating BigSmartStatus:', error);
            return null;
        }
    }
    async updateBigSmartStatus(
        input: UpdateBigSmartStatusInput
    ): Promise<BigSmartStatus> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updateBigSmartStatus,
                    variables: {
                        input
                    }
                })
            ).data.updateBigSmartStatus;
            if (date) return date as BigSmartStatus;
        } catch (error) {
            console.error('Error updated BigSmartStatus:', error);
            return null;
        }
    }
}
